import * as React from "react";
import { Datagrid, TextField } from "react-admin";
import { RDDDatetimeField } from "../../../../Components/RDDDatetimeField";
import { AcceptOrRejectColumn } from "./AcceptOrRejectColumn";
import RequestStatusField from "../../../../Components/ReferenceFields/RequestStatus/RequestStatusField";
export const DataGridColumns = props => {
  return (
    <Datagrid {...props} optimized hasBulkActions={false}>
      <AcceptOrRejectColumn label="Actions" remarkAddClick={props.remarkAddClick} />
      <RequestStatusField label="Status" />
      <TextField source="refNo" label="Ref No" />
      <TextField source="customerPo" label="Customer Po" />
      <RDDDatetimeField label="Request Delivery Date" />
      <TextField source="customerRequestComponent" label="Pn" />
      <TextField source="unserviceable.sn" label="Core Unit Sn" />
      <TextField source="currentPbhNote" label="Current PBH Note" />
    </Datagrid>
  );
};

export default DataGridColumns;
